<template>
  <div v-if="this.loading">Loading data</div>
  <div v-else>
    <BreadCrumb />
    <div class="plant-images-base">
      <img
        v-if="plant.imgs[0]"
        :src="getImg(plant.imgs[0])"
        class="plant-images-item"
        img-alt="image plant"
      />
      <img
        v-if="plant.imgs[1]"
        :src="getImg(plant.imgs[1])"
        class="plant-images-item"
        img-alt="image plant"
      />
    </div>
    <ParagraphCustom :title="this.plant.name">
      <div class="details">
        <div class="plant-text">
          <p>Botanic name:&nbsp;</p>
          <p class="plant-text-scientific">{{ this.plant.botanicName }}</p>
        </div>
        <div class="plant-text">
          <p>Family name:&nbsp;</p>
          <p class="plant-text-scientific">{{ this.plant.familyName }}</p>
        </div>
        <div class="plant-text">
          <p>Origin:&nbsp;{{ this.plant.origins.join() }}</p>
        </div>
        <div class="plant-text">
          <p>Continent:&nbsp;{{ this.plant.continent.join() }}</p>
        </div>
        <p>
          Type of plant:&nbsp;
          <span
            v-for="category in plant.categories"
            :key="category.id"
            class="badge"
            v-bind:style="{
              'background-color': getCategoryColor(category.key),
            }"
            >{{ category.label }}
          </span>
        </p>
      </div>
    </ParagraphCustom>
    <ParagraphCustom title="Description" color="secondary">
      <p>{{ this.plant.description }}</p>
    </ParagraphCustom>
    <ParagraphCustom color="secondary">
      <div class="plant-text">Sources:</div>
    </ParagraphCustom>
  </div>
</template>
<script>
import PlantService from "@/services/PlantService.js";
import Plant from "@/models/Plant";
import BreadCrumb from "../BreadCrumb/BreadCrumb.vue";
import ParagraphCustom from "../ParagraphCustom.vue";
export default {
  name: "PlantPage",
  components: { BreadCrumb, ParagraphCustom },
  data() {
    return {
      plant: Plant,
      loading: true,
    };
  },
  methods: {
    getImg: function (img) {
      return process.env.VUE_APP_URL_IMAGE + img;
    },
    getCategoryColor: function (keyCategory) {
      return this.colorHexaCategoryList.find(
        (colorCategory) => colorCategory.key === keyCategory
      ).color;
    },
    async fetchDataPlant(idPlant) {
      PlantService.getPlant(idPlant)
        .then((res) => {
          this.plant = res;
          this.loading = false;
          if (this.plant.origins.includes("New Zealand")) {
            this.$route.meta.breadCrumb[1] = {
              text: "New Zealand",
              to: {
                path: `/category/all`,
              },
            };
            this.$route.meta.breadCrumb[2] = {
              text: this.plant.categories[0].label,
              to: {
                path: `/category/${this.plant.categories[0].key}`,
              },
            };
          }

          this.$route.meta.breadCrumb[3] = { text: this.plant.name };
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$watch(
      () => this.$route,
      (toParams) => {
        this.fetchDataPlant(toParams.id);
      }
    );
  },
  created() {
    this.fetchDataPlant(this.$route.params.id);
  },
};
</script>
<style lang="scss" scoped>
.plant-images-base {
  display: flex;
  flex-direction: column;
  gap: $spacing-small;
  align-items: center;
  @media (min-width: $constraint-width-small) {
    flex-direction: row;
    justify-content: center;
  }
}
.plant-images-item {
  width: 100%;
  @media (min-width: $constraint-width-small) {
    width: 350px;
    min-width: 200px;
  }
}
.plant-text {
  display: flex;
  word-wrap: break-word;
}
.details {
  display: flex;
  flex-direction: column;
  @media (min-width: $constraint-width-small) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
.plant-text-scientific {
  font-style: italic;
}
.badge {
  background-color: $color-qrious-purple-gradient;
  border-radius: 50rem;
  color: #fff;
  font-size: 0.69rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
  padding: 0.25em 0.65em;
  vertical-align: baseline;
}
</style>
